var BlockView = require('views/block/base-block-view');

var MultimediaBlockView = BlockView.extend({
  initialize: function (opts) {
    if (EF.enrollment && EF.enrollment.attributes) {
      const enrollmentAutoPlay = EF.enrollment.get('autoPlay');
      const modelAutoPlay = this.model.get('auto_play');
      if (enrollmentAutoPlay !== undefined) {
        if (modelAutoPlay === undefined) {
          this.model.set('auto_play', EF.enrollment.get('autoPlay'));
        }
        if (enrollmentAutoPlay === false && modelAutoPlay === true) {
          this.model.set('auto_play', false);
        }
      }
    }
    BlockView.prototype.initialize.call(this, opts);
  },

  dispose: function () {
    BlockView.prototype.dispose.call(this, arguments);
  },
});

module.exports = MultimediaBlockView;
